import httpClient from './httpClient';

export const SYNC_BRANCH = '/backoffice/sync/branches';

export const postSyncBranchAPI = (data) => httpClient.post(SYNC_BRANCH, data);
